import type { Theme } from "../types/Theme";
import { alpha } from "./Mixins";
import {
    MODERN_GRID_ROW_BORDER_COLOR,
    MODERN_GRID_SUBHEADER_MUTED,
} from "./gridThemeTokens";
import { shouldUseModernTheme } from "./navigationButtonThemeColors";

export const MODERN_SLIDER_TRACK_HEIGHT_PX = 4;
export const MODERN_SLIDER_HANDLE_SIZE_PX = 12;
export const MODERN_SLIDER_FOCUS_RING_WIDTH_PX = 8;
export const MODERN_SLIDER_FOCUS_RING_ALPHA = 0.3;
export const MODERN_SLIDER_HANDLE_LABEL_COLOR = "#242424";
export const MODERN_SLIDER_HANDLE_LABEL_FONT_WEIGHT = 600;

export function useModernSliderStyles(theme: Theme): boolean {
    return shouldUseModernTheme(theme);
}

/**
 * Modern rail/track corner radius: 0.75× the field radius, which reproduces the shipped modern look
 * at the 8px default (6px) while still following Field Settings → Corners, and squares at "Squared".
 * Legacy keeps its own `BorderRadius / 4` rail math, tuned for its taller rail.
 */
const MODERN_SLIDER_TRACK_RADIUS_RATIO = 0.75;

export function resolveModernSliderTrackBorderRadius(theme: Theme): number {
    return theme.BorderRadius * MODERN_SLIDER_TRACK_RADIUS_RATIO;
}

export function resolveSliderTrackUnfilledColor(): string {
    return MODERN_GRID_ROW_BORDER_COLOR;
}

export function resolveSliderTrackFilledColor(theme: Theme): string {
    return theme.PrimaryColor;
}

export function resolveSliderHandleFillColor(theme: Theme): string {
    return theme.WhiteColor;
}

export function resolveSliderHandleBorderColor(theme: Theme): string {
    return theme.PrimaryColor;
}

export function resolveSliderEndpointLabelColor(): string {
    return MODERN_GRID_SUBHEADER_MUTED;
}

export function resolveSliderHandleLabelColor(): string {
    return MODERN_SLIDER_HANDLE_LABEL_COLOR;
}

export function resolveSliderHandleLabelFontWeight(): number {
    return MODERN_SLIDER_HANDLE_LABEL_FONT_WEIGHT;
}

export function resolveSliderFocusRingShadow(theme: Theme): string {
    return `0 0 0 ${MODERN_SLIDER_FOCUS_RING_WIDTH_PX}px ${alpha(
        theme.PrimaryColor,
        MODERN_SLIDER_FOCUS_RING_ALPHA,
    )}`;
}
